<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre8" id="pgepubid00017">Full-page Illustrations</h2>
<table class="calibre14" summary="Illustrations">
<tbody class="calibre3">
<tr class="calibre4">
<td class="calibre6"><a class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0002#image_01">PRINCESS LABAM</a></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="c4"><a class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0002#image_01">Frontispiece</a></td>
</tr>
<tr class="calibre4">
<td class="calibre6"><a class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0004#image_02">THE LION AND THE CRANE</a></td>
<td class="calibre6"></td>
<td class="c4">To face page</td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="tocpg"><a class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0004#Page_2">2</a></td>
</tr>
<tr class="calibre4">
<td class="calibre6"><a class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0007#image_03">PUNCHKIN</a></td>
<td class="calibre6"></td>
<td class="calibre15">"</td>
<td class="calibre15"></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="tocpg"><a class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0007#Page_36">36</a></td>
</tr>
<tr class="calibre4">
<td class="calibre6"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0011#image_04" title="Link target outside of Sample">LOVING LAILI</span></td>
<td class="calibre6"></td>
<td class="calibre15">"</td>
<td class="calibre15"></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="tocpg"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0011#Page_64" title="Link target outside of Sample">64</span></td>
</tr>
<tr class="calibre4">
<td class="calibre6"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0015#image_05" title="Link target outside of Sample">THE CHARMED RING</span></td>
<td class="calibre6"></td>
<td class="calibre15">"</td>
<td class="calibre15"></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="tocpg"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0015#Page_96" title="Link target outside of Sample">96</span></td>
</tr>
<tr class="calibre4">
<td class="calibre6"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0019#image_06" title="Link target outside of Sample">THE SON OF SEVEN QUEENS</span></td>
<td class="calibre6"></td>
<td class="calibre15">"</td>
<td class="calibre15"></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="tocpg"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0019#Page_120" title="Link target outside of Sample">120</span></td>
</tr>
<tr class="calibre4">
<td class="calibre6"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0022#image_07" title="Link target outside of Sample">RAJA RASALU</span></td>
<td class="calibre6"></td>
<td class="calibre15">"</td>
<td class="calibre15"></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="tocpg"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0022#Page_146" title="Link target outside of Sample">146</span></td>
</tr>
<tr class="calibre4">
<td class="calibre6"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0025#image_08" title="Link target outside of Sample">BOY WITH MOON ON FOREHEAD</span></td>
<td class="calibre6"></td>
<td class="calibre15">"</td>
<td class="calibre15"></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="tocpg"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0025#Page_165" title="Link target outside of Sample">165</span></td>
</tr>
<tr class="calibre4">
<td class="calibre6"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0028#image_09" title="Link target outside of Sample">DEMON WITH MATTED HAIR</span></td>
<td class="calibre6"></td>
<td class="calibre15">"</td>
<td class="calibre15"></td>
<td class="calibre6"></td>
<td class="calibre6"></td>
<td class="tocpg"><span class="pcalibre pcalibre2 pcalibre1" href="#/Text/Section0028#Page_196" title="Link target outside of Sample">196</span></td>
</tr>
</tbody>
</table>
<div class="blockquot">
<p class="center1"></p>
</div>
<p class="calibre1"><a class="pcalibre pcalibre2 pcalibre1" id="Page_1" title="[1]"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?2b64eff2